import React, { useEffect, useState } from "react";
import { useTravelAdvisoryQuery } from "./graphql/query";
import Tabs from "./components/Tabs";
import Travel from "./components/Travel";
import Airport from "./components/Airport";
import StayInformed from "./components/StayInformed";
import "./travel-advisory.css";
import CommonTextBelowBanner from "../../components/common/banner/CommonTextBelowBanner";
import Banner from "./components/Banner";
import FlightStatus from "../winter-template/components/FlightStatus";
import { useCheckInQuery } from "../check-in/graphql/query";
import DynamicAdvisoryBanner from "./components/DynamicAdvisoryBanner";
import PublicHealth from "./components/PublicHealth";
import OverViewWithCta from "./components/OverViewWithCta";
import FlightInfo from "./components/FlighInfo";
import AiSummaryWidget from "../../components/ai-summary/AiSummaryWidget";
import Faqs from "./components/FAQ";

const TravelAdvisoryTemplate = ({ keyword }) => {
  // const travelAdvisoryData = useTravelAdvisoryQuery(keyword);

  const travelAdvisory = useTravelAdvisoryQuery(keyword);
  const [bannerData, setBannerData] = useState(null);
  const [isBannerLoaded, setIsBannerLoaded] = useState(false);
  const {
    tab_section,
    before_travel_section,
    at_airport_section,
    stay_info_section,
    banner_section,
    faq_section,
  } = travelAdvisory || {};

  useEffect(() => {
    const fetchBannerSection = async () => {
      try {
        const query =
          "populate[banner_section][populate][banner_images][populate]=*" +
          "&populate[banner_section][populate][left_arrow][populate]=*" +
          "&populate[banner_section][populate][right_arrow][populate]=*";

        const res = await fetch(`/api/travel-advisories?${query}`);
        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
        const json = await res.json();
        const matchedItem = json?.data?.find(
          (item) => item.keyword === keyword,
        );
        setBannerData(matchedItem?.banner_section);
        setIsBannerLoaded(true);
      } catch (err) {
        console.error("Error fetching banner section:", err);
        setIsBannerLoaded(true); // still continue to render rest
      }
    };

    fetchBannerSection();
  }, []);

  if (!isBannerLoaded) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p></p>
      </div>
    );
  }
  return (
    <div className="travelAdvisory">
      {/* <Banner data={banner_section} /> */}
      <DynamicAdvisoryBanner bannerData={bannerData} />
      <AiSummaryWidget/>
      {keyword === "ebola-advisory" && (
        <OverViewWithCta data={before_travel_section?.[0]} size={true} />
      )}
      <Tabs data={tab_section} keyword={keyword}/>
      <div
        className={`${keyword === "ebola-advisory" ? "lg:mt-[-2.5vw]" : ""}`}
      >
        <FlightInfo />
      </div>
      {/* <Travel id="first-tab" data={before_travel_section} /> */}
      <Airport id="second-tab" data={at_airport_section} keyword={keyword}/>
      {/* <StayInformed id="third-tab" data={stay_info_section} /> */}
      {keyword === "ebola-advisory" && <Faqs data={faq_section} />}
      {keyword === "ebola-advisory" && <PublicHealth />}
    </div>
  );
};

export default TravelAdvisoryTemplate;
